import { mapRangeVariantToDateRange } from '../../../../../shared/utils/date';
import { formatToDefaultDateFormat } from '../../support/Dates/dateUtils';
import type { DateRange as StringBasedDateRange } from '../../types/dateRangeTypes';

export type DateRangeVariant = (typeof DATE_RANGES_KEYS)[number];
export const DATE_RANGES_KEYS = [
  'today',
  'yesterday',
  'last_7_days',
  'last_14_days',
  'last_30_days',
  'this_week',
  'last_week',
  'this_month',
  'last_month',
  'this_quarter',
  'last_quarter',
  'custom',
] as const;

function isNumericRangeVariant(rangeInDays: any): rangeInDays is number {
  return typeof rangeInDays === 'number';
}

export const mapRangeInDaysToRangeVariant = (defaultRange?: number): DateRangeVariant => {
  switch (defaultRange) {
    case 1:
      return 'yesterday';
    case 3:
      return 'last_7_days';
    case 7:
      return 'last_7_days';
    case 14:
      return 'last_14_days';
    case 30:
      return 'last_30_days';
    case 90:
      return 'last_quarter';
    default:
      return 'custom';
  }
};

export const convertDateRangeVariantToStringRange = (rangeVariant: DateRangeVariant): StringBasedDateRange => {
  const dateRange = mapRangeVariantToDateRange(rangeVariant);

  return {
    start_date: dateRange[0] ? formatToDefaultDateFormat(dateRange[0]) : '',
    end_date: dateRange[1] ? formatToDefaultDateFormat(dateRange[1]) : '',
  };
};

export const convertToValidDateRangeVariant = (rangeVariant: DateRangeVariant | number): DateRangeVariant => {
  if (isNumericRangeVariant(rangeVariant)) {
    const stringRangeVariant = mapRangeInDaysToRangeVariant(rangeVariant);

    return stringRangeVariant;
  }

  return rangeVariant;
};
